import * as React from 'react';
import { observer } from 'mobx-react-lite';

interface TariffHeaderProps {
    name: string;
    badge?: React.ReactNode;
    forPartners?: boolean;
}

export const TariffHeader: React.FC<TariffHeaderProps> = observer(({ name, badge, forPartners }) => {
    const nameClassName = `whitespace-nowrap text-[1.6rem] font-bold leading-[1.6rem] lg:text-[2rem] lg:leading-[2rem]${
        forPartners ? ' lg:text-[2.6rem] lg:leading-[2.6rem]' : ''
    }`;

    return (
        <div className="flex min-h-[3.8rem] w-full items-center">
            <div className={nameClassName}>{name}</div>
            <div className="mx-[1.6rem] inline-block h-px w-full bg-[var(--tariff-color-light)]" />
            {badge && badge}
        </div>
    );
});
